const FONT = 82;
const BASELINE = 104;
const BEACH_GAP = 3;
const STROKE = 3;
const WORD_GAP = 26;
const POP_GAP = 6;
const BANG_GAP = 4;
const BEA_RIGHT = 132.4;
const C_LEFT = 28.7;
const C_RIGHT = 20;
const H_WIDTH = 48.6;
const P_WIDTH = 48.1;
const BANG_WIDTH = 30.1;
const O_SIZE = 64;
const O_R = O_SIZE / 2;
const O_FILL = 0.4;
const C_CY = 84.5;
const O_CY = 74;
const VIEW_W = 540;
const VIEW_H = 156;

const cX = BEA_RIGHT + STROKE + BEACH_GAP + C_LEFT;
const hX = cX + C_RIGHT + BEACH_GAP;
const hEnd = hX + H_WIDTH;
const popX = hEnd + STROKE + WORD_GAP;
const oVisualR = O_SIZE * O_FILL;
const oX = P_WIDTH + STROKE + POP_GAP + oVisualR;
const p2X = oX + oVisualR + STROKE + POP_GAP;
const bangX = p2X + P_WIDTH + BANG_GAP;
const popEnd = bangX + BANG_WIDTH;
const contentWidth = popX + popEnd + STROKE;
const origin = Math.round((VIEW_W - contentWidth) / 2);

export function beachLogoMarkup(reduceMotion: boolean): string {
  const motion = reduceMotion ? " reduce" : "";
  const waveY = 128;
  const waveX0 = origin - 4;
  const waveX1 = origin + contentWidth + 4;
  return `
  <svg class="beach-logo${motion}" viewBox="0 0 ${VIEW_W} ${VIEW_H}" preserveAspectRatio="xMidYMid meet" overflow="visible" role="img" aria-label="Beach POP!">
    <defs>
      <linearGradient id="sandFill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#ffe9b0"/>
        <stop offset="48%" stop-color="#f3d27a"/>
        <stop offset="100%" stop-color="#c9922a"/>
      </linearGradient>
      <linearGradient id="discRed" x1="0.15" y1="0" x2="0.9" y2="1">
        <stop offset="0%" stop-color="#ff8a7a"/>
        <stop offset="42%" stop-color="#e23b3b"/>
        <stop offset="100%" stop-color="#9b1b2e"/>
      </linearGradient>
      <linearGradient id="discRim" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#fff3c4"/>
        <stop offset="100%" stop-color="#e8c56a"/>
      </linearGradient>
    </defs>
    <path class="logo-wave" d="M${waveX0} ${waveY}c70-8 150-14 250-8 90 5 160 3 ${waveX1 - waveX0 - 20}-10" fill="none" stroke="#7fd7ee" stroke-width="5.5" stroke-linecap="round"/>
    <path class="logo-foam" d="M${waveX0 + 16} ${waveY + 8}c70-5 150-5 250-1" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" opacity="0.55"/>
    <g class="logo-words" transform="translate(${origin} 0)" fill="url(#sandFill)" stroke="#8a5a28" stroke-width="6" stroke-linejoin="round" paint-order="stroke fill" font-family="Trebuchet MS, Arial, sans-serif" font-size="${FONT}" font-weight="800">
      <g class="word-beach">
        <text class="logo-bea" x="0" y="${BASELINE}" letter-spacing="-3">Bea</text>
        <g class="logo-c-wrap" transform="translate(${cX} ${C_CY})" stroke="none">
          <g class="logo-c">
            <path fill="#6e1420" d="M20-16.5A29 22.5 0 1 0 20 16.5L9 9A16 12.5 0 1 1 9-9Z"/>
            <path fill="url(#discRed)" d="M18.5-15A27 21 0 1 0 18.5 15L9 8A16 12 0 1 1 9-8Z"/>
            <path fill="none" stroke="url(#discRim)" stroke-width="3" stroke-linecap="round" d="M8-9A17 13 0 1 0 8 9"/>
            <path fill="none" stroke="rgba(255,255,255,0.55)" stroke-width="2.3" stroke-linecap="round" d="M-17-8C-9-17 5-19 14-10"/>
            <ellipse cx="-7" cy="-7" rx="6" ry="3" fill="rgba(255,255,255,0.28)" transform="rotate(-28)"/>
          </g>
        </g>
        <text class="logo-h" x="${hX}" y="${BASELINE}">h</text>
      </g>
      <g class="word-pop" transform="translate(${popX} 0)">
        <text class="logo-p1" x="0" y="${BASELINE}">P</text>
        <g class="logo-o" transform="translate(${oX} ${O_CY})" stroke="none">
          <g class="logo-ball">
            <image class="logo-gold-img" href="" x="${-O_R}" y="${-O_R}" width="${O_SIZE}" height="${O_SIZE}" preserveAspectRatio="xMidYMid meet" stroke="none"/>
          </g>
          <g class="logo-shards" aria-hidden="true" stroke="none">
            <circle class="s1" cx="0" cy="0" r="3.4" fill="#f0b429"/>
            <circle class="s2" cx="0" cy="0" r="3" fill="#ffe566"/>
            <circle class="s3" cx="0" cy="0" r="2.8" fill="#fff8d0"/>
            <circle class="s4" cx="0" cy="0" r="2.5" fill="#b8860b"/>
            <circle class="s5" cx="0" cy="0" r="3" fill="#ffd24a"/>
            <circle class="s6" cx="0" cy="0" r="2.5" fill="#fff3b0"/>
          </g>
        </g>
        <text class="logo-p2" x="${p2X}" y="${BASELINE}">P</text>
        <text class="logo-bang" x="${bangX}" y="${BASELINE}">!</text>
      </g>
    </g>
    <g class="logo-shells" fill="#f4e2c8" stroke="#c9a06a" stroke-width="1.2">
      <path class="logo-shell-l" d="M${origin + 40} 130c7-8 18-8 24 2-10 3-16 3-24-2z"/>
      <path class="logo-shell-r" d="M${origin + contentWidth - 64} 128c7-8 17-7 23 3-9 3-15 3-23-3z"/>
    </g>
  </svg>`;
}

function asGraphics(root: ParentNode, selector: string): SVGGraphicsElement | null {
  const node = root.querySelector(selector);
  return node instanceof SVGGraphicsElement ? node : null;
}

function setWave(svg: SVGSVGElement, start: number, width: number): void {
  const waveY = 128;
  const waveX0 = start - 4;
  const waveX1 = start + width + 4;
  const wave = svg.querySelector(".logo-wave");
  const foam = svg.querySelector(".logo-foam");
  const left = svg.querySelector(".logo-shell-l");
  const right = svg.querySelector(".logo-shell-r");
  if (wave instanceof SVGPathElement) {
    wave.setAttribute("d", `M${waveX0} ${waveY}c70-8 150-14 250-8 90 5 160 3 ${waveX1 - waveX0 - 20}-10`);
  }
  if (foam instanceof SVGPathElement) {
    foam.setAttribute("d", `M${waveX0 + 16} ${waveY + 8}c70-5 150-5 250-1`);
  }
  if (left instanceof SVGPathElement) {
    left.setAttribute("d", `M${start + 40} 130c7-8 18-8 24 2-10 3-16 3-24-2z`);
  }
  if (right instanceof SVGPathElement) {
    right.setAttribute("d", `M${start + width - 64} 128c7-8 17-7 23 3-9 3-15 3-23-3z`);
  }
}

/** Positions Beach / POP from real ink boxes so the C sits with e-a-h and the gold O stays round. */
export function layoutBeachLogo(svg: SVGSVGElement): void {
  const bea = asGraphics(svg, ".logo-bea");
  const cWrap = asGraphics(svg, ".logo-c-wrap");
  const cInner = asGraphics(svg, ".logo-c");
  const h = asGraphics(svg, ".logo-h");
  const pop = asGraphics(svg, ".word-pop");
  const words = asGraphics(svg, ".logo-words");
  const p1 = asGraphics(svg, ".logo-p1");
  const oWrap = asGraphics(svg, ".logo-o");
  const p2 = asGraphics(svg, ".logo-p2");
  const bang = asGraphics(svg, ".logo-bang");
  if (!bea || !cWrap || !cInner || !h || !pop || !words || !p1 || !oWrap || !p2 || !bang) return;

  const beaBox = bea.getBBox();
  const cBox = cInner.getBBox();
  if (beaBox.width < 8 || cBox.width < 8) return;
  const cY = BASELINE + STROKE - (cBox.y + cBox.height);
  const cXNow = beaBox.x + beaBox.width + STROKE + BEACH_GAP - cBox.x;
  cWrap.setAttribute("transform", `translate(${cXNow} ${cY})`);

  const cRight = cXNow + cBox.x + cBox.width;
  h.setAttribute("x", String(cRight + BEACH_GAP));

  const hBox = h.getBBox();
  const popXNow = hBox.x + hBox.width + STROKE + WORD_GAP;
  pop.setAttribute("transform", `translate(${popXNow} 0)`);

  const p1Box = p1.getBBox();
  const visualR = O_SIZE * O_FILL;
  const oXNow = p1Box.x + p1Box.width + STROKE + POP_GAP + visualR;
  const pCapCenter = BASELINE - Math.min(32, p1Box.height * 0.34);
  oWrap.setAttribute("transform", `translate(${oXNow} ${pCapCenter})`);

  p2.setAttribute("x", String(oXNow + visualR + STROKE + POP_GAP));
  const p2Box = p2.getBBox();
  bang.setAttribute("x", String(p2Box.x + p2Box.width + BANG_GAP));

  const bangBox = bang.getBBox();
  const content = popXNow + bangBox.x + bangBox.width + STROKE;
  const start = Math.round((VIEW_W - content) / 2);
  words.setAttribute("transform", `translate(${start} 0)`);
  setWave(svg, start, content);
}
